import type { NounsPayload } from '@/core/types';

import type { AppDefinition } from '../types';
import { CardFront } from './CardFront';

export const nounsApp: AppDefinition<NounsPayload> = {
  id: 'nouns',
  display_name: 'Nouns',
  CardFront,
};
